// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.docs-sidebar {
  height: calc(100vh - 70px);
  position: sticky;
  top: 70px;
  background: #ffffff;
}

.docs-sidebar .nav-link {
  color: #64748b;
  padding: 10px 15px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.docs-sidebar .nav-link:hover,
.docs-sidebar .nav-link.active {
  background: #f5f3ff;
  color: var(--primary-purple);
}

.code-block {
  font-family: "Fira Code", monospace;
  font-size: 13px;
  overflow-x: auto;
  border: 1px solid #334155;
}

.mb-100 {
  margin-bottom: 100px;
}
.nav-label {
  font-size: 11px;
  letter-spacing: 1px;
  margin-bottom: 5px;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/styles/docs.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".docs-sidebar {\n  height: calc(100vh - 70px);\n  position: sticky;\n  top: 70px;\n  background: #ffffff;\n}\n\n.docs-sidebar .nav-link {\n  color: #64748b;\n  padding: 10px 15px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.docs-sidebar .nav-link:hover,\n.docs-sidebar .nav-link.active {\n  background: #f5f3ff;\n  color: var(--primary-purple);\n}\n\n.code-block {\n  font-family: \"Fira Code\", monospace;\n  font-size: 13px;\n  overflow-x: auto;\n  border: 1px solid #334155;\n}\n\n.mb-100 {\n  margin-bottom: 100px;\n}\n.nav-label {\n  font-size: 11px;\n  letter-spacing: 1px;\n  margin-bottom: 5px;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
